/* eslint-disable @typescript-eslint/no-unused-vars, react-hooks/exhaustive-deps */
import React,{useState,useEffect,useCallback}from'react';
import{useNavigate,useParams}from'react-router-dom';
import Layout from'../components/layout/Layout';
import api from'../services/api';
import {useTranslation} from 'react-i18next';
import FileShaClaimButton from '../components/common/FileShaClaimButton';
import { useMultiMaster } from '../hooks/useMaster';

const BTN ="bg-[#02357A] hover:bg-[#015CA6] text-white font-bold py-2.5 px-5 rounded-xl text-sm transition-all disabled:opacity-50";
const BTN2="bg-white hover:bg-slate-50 text-slate-700 font-semibold py-2.5 px-5 rounded-xl text-sm border border-slate-200 transition-all";
const BTNT="bg-[#039089] hover:bg-teal-700 text-white font-bold py-2.5 px-5 rounded-xl text-sm transition-all disabled:opacity-50";
const INPF="w-full border-2 border-slate-200 rounded-xl px-3.5 py-2.5 text-sm focus:outline-none focus:border-[#039089] transition-all";

const SECTION=({title,children,icon,badge}:any)=>(
  <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-5 mb-4">
    <div className="flex items-center justify-between mb-4 pb-2 border-b">
      <h3 className="font-bold text-gray-800 text-base flex items-center gap-2">{icon&&<span>{icon}</span>}{title}</h3>
      {badge&&<span className={`text-xs px-2 py-0.5 rounded-full font-bold border ${badge==='Required'?'bg-red-50 text-red-600 border-red-200':'bg-slate-50 text-slate-400 border-slate-200'}`}>{badge}</span>}
    </div>
    {children}
  </div>
);
const FLD=({label,required,children}:any)=>(
  <div><label className="block text-xs font-bold text-slate-500 uppercase tracking-wide mb-1.5">{label}{required&&<span className="text-red-500 ml-1">*</span>}</label>{children}</div>
);
const SEL=({value,onChange,children}:any)=>(
  <select value={value} onChange={onChange} className="w-full border-2 border-slate-200 rounded-xl px-3.5 py-2.5 text-sm focus:outline-none focus:border-[#039089] transition-all bg-white">{children}</select>
);

const COUNTIES=['Mombasa','Kwale','Kilifi','Tana River','Lamu','Taita-Taveta','Garissa','Wajir','Mandera','Marsabit','Isiolo','Meru','Tharaka-Nithi','Embu','Kitui','Machakos','Makueni','Nyandarua','Nyeri','Kirinyaga',"Murang'a",'Kiambu','Turkana','West Pokot','Samburu','Trans Nzoia','Uasin Gishu','Elgeyo-Marakwet','Nandi','Baringo','Laikipia','Nakuru','Narok','Kajiado','Kericho','Bomet','Kakamega','Vihiga','Bungoma','Busia','Siaya','Kisumu','Homa Bay','Migori','Kisii','Nyamira','Nairobi'];
const INSURANCE_PROVIDERS=['SHA/SHIF','NHIF','AAR Healthcare','Jubilee Health Insurance','Madison Insurance','Resolution Insurance','GA Insurance','Britam','CIC Insurance','APA Insurance','UAP Insurance','Old Mutual','Liberty Health','Sanlam','Minet','Other Private Insurance'];

const DEF:any={
  firstName:'',lastName:'',middleName:'',dateOfBirth:'',gender:'',bloodGroup:'',
  maritalStatus:'',religion:'',nationality:'Kenyan',occupation:'',educationLevel:'',
  mobile:'',alternatePhone:'',email:'',
  addressLine1:'',city:'',county:'',subCounty:'',ward:'',postalCode:'',country:'Kenya',state:'',
  emergencyContactName:'',emergencyContactPhone:'',emergencyContactRelation:'',
  nationalId:'',alienId:'',hudumaNumber:'',kenyanIdType:'NATIONAL_ID',passportNumber:'',
  shaBeneficiaryCrId:'',nhifNumber:'',
  insuranceId:'',insuranceProvider:'',insurancePolicyNumber:'',insuranceExpiry:'',groupInsuranceNumber:'',
  knownAllergies:'',chronicConditions:'',currentMedications:'',
  referredBy:'',referralSource:'',referralHospital:'',
  patientType:'GENERAL',isVIP:false,isMLCPatient:false,
  fatherName:'',husbandName:'',motherName:'',
  preferredLanguage:'English',requiresInterpreter:false,
  isSHAPatient:false,hasOtherInsurance:false,
  otherInsuranceProvider:'',otherPolicyNumber:'',otherInsuranceExpiry:'',
};

export default function PatientRegistrationPage(){
  const {t}=useTranslation();
  const nav=useNavigate();
  const {id}=useParams();
  const isEdit=!!id;

  const [saving,setSaving]=useState(false);
  const [msg,setMsg]=useState('');
  const [error,setError]=useState('');
  const [registeredPatient,setRegisteredPatient]=useState<any>(null);
  const [duplicates,setDuplicates]=useState<any[]>([]);
  const [showDuplicateWarning,setShowDuplicateWarning]=useState(false);

  // SHA
  const [shaResult,setShaResult]=useState<any>(null);
  const [shaSearching,setShaSearching]=useState(false);
  const [shaPatient,setShaPatient]=useState<any>(null);

  // Insurance eligibility
  const [insuranceEligibility,setInsuranceEligibility]=useState<any>(null);
  const [checkingInsurance,setCheckingInsurance]=useState(false);

  const [form,setForm]=useState<any>({...DEF});
  const f=(k:string,v:any)=>setForm((x:any)=>({...x,[k]:v}));
  const {masters:adminMasters}=useMultiMaster(['COUNTY','SUB_COUNTY']);
  const countyOptions=(adminMasters.COUNTY||[]).map(c=>c.value);
  const counties=countyOptions.length?countyOptions:COUNTIES;
  const subCountyOptions=(adminMasters.SUB_COUNTY||[]).filter(s=>s.extraData?.county===(form.county||form.state)).map(s=>s.value);

  // Load for edit
  const load=useCallback(async()=>{
    if(!isEdit)return;
    try{
      const r=await api.getPatient(id!).catch(()=>({data:null}));
      if(r?.data){
        const p=r.data;
        setForm((prev:any)=>({...prev,
          firstName:p.firstName||p.first_name||'',
          lastName:p.lastName||p.last_name||'',
          middleName:p.middleName||p.middle_name||'',
          dateOfBirth:(p.dateOfBirth||p.date_of_birth||'').split('T')[0],
          gender:(p.gender||'').toUpperCase(),
          bloodGroup:p.bloodGroup||p.blood_group||'',
          maritalStatus:p.maritalStatus||p.marital_status||'',
          religion:p.religion||'',
          nationality:p.nationality||'Kenyan',
          occupation:p.occupation||'',
          educationLevel:p.educationLevel||p.education_level||'',
          mobile:p.mobile||p.phone||'',
          alternatePhone:p.alternatePhone||p.alternate_phone||'',
          email:p.email||'',
          addressLine1:p.addressLine1||p.address_line1||p.address||'',
          city:p.city||'',
          county:p.county||p.state||'',
          state:p.state||p.county||'',
          subCounty:p.subCounty||p.sub_county||'',
          ward:p.ward||'',
          postalCode:p.postalCode||p.postal_code||'',
          country:p.country||'Kenya',
          emergencyContactName:p.emergencyContactName||p.emergency_contact_name||'',
          emergencyContactPhone:p.emergencyContactPhone||p.emergency_contact_phone||'',
          emergencyContactRelation:p.emergencyContactRelation||p.emergency_contact_relation||'',
          nationalId:p.nationalId||p.national_id||'',
          alienId:p.alienId||p.alien_id||'',
          hudumaNumber:p.hudumaNumber||p.huduma_number||'',
          kenyanIdType:p.kenyanIdType||p.kenyan_id_type||'NATIONAL_ID',
          passportNumber:p.passportNumber||p.passport_number||'',
          shaBeneficiaryCrId:p.shaBeneficiaryCrId||p.sha_beneficiary_cr_id||'',
          nhifNumber:p.nhifNumber||p.nhif_number||'',
          insuranceProvider:p.insuranceProvider||p.insurance_provider||'',
          insurancePolicyNumber:p.insurancePolicyNumber||p.insurance_policy_number||'',
          insuranceExpiry:(p.insuranceExpiry||p.insurance_expiry||'').split('T')[0],
          groupInsuranceNumber:p.groupInsuranceNumber||p.group_insurance_number||'',
          knownAllergies:p.knownAllergies||p.known_allergies||'',
          chronicConditions:p.chronicConditions||p.chronic_conditions||'',
          patientType:p.patientType||p.patient_type||'GENERAL',
          isVIP:p.isVIP||p.is_vip||false,
          fatherName:p.fatherName||p.father_name||'',
          husbandName:p.husbandName||p.husband_name||'',
          motherName:p.motherName||p.mother_name||'',
          preferredLanguage:p.preferredLanguage||p.preferred_language||'English',
          requiresInterpreter:p.requiresInterpreter||false,
          isSHAPatient:!!(p.shaBeneficiaryCrId||p.sha_beneficiary_cr_id||
            (p.insuranceProvider||p.insurance_provider||'').includes('SHA')||
            (p.insuranceProvider||p.insurance_provider||'').includes('SHIF')),
        }));
      }
    }catch{}
  },[id,isEdit]);

  useEffect(()=>{load();},[load]);

  // SHA search & eligibility
  const searchAndFillFromSHA=async()=>{
    const idNo=form.nationalId||form.passportNumber||form.alienId;
    const ID_MAP:Record<string,string>={'NATIONAL_ID':'National ID','PASSPORT':'Passport','ALIEN_ID':'Alien ID','REFUGEE_ID':'Refugee ID','BIRTH_CERT':'Birth Certificate','HUDUMA_NUMBER':'Mandate Number'};
    const idType=ID_MAP[form.kenyanIdType||'NATIONAL_ID']||'National ID';
    if(!idNo){setError('Enter ID Number first');return;}
    setShaSearching(true);setShaPatient(null);setShaResult(null);setError('');
    try{
      const m=await import('../services/sha.api');
      const rs=await m.shaSearchPatient(idNo,idType);
      const p=rs?.data;
      const crId=p?.id||p?.memberCrNumber||'';
      const fullName=[p?.first_name,p?.middle_name,p?.last_name].filter(Boolean).join(' ');
      if(crId){
        setShaPatient({crId,fullName,gender:p?.gender,phone:p?.phone});
        setForm((x:any)=>({...x,
          firstName:x.firstName||p?.first_name||'',
          middleName:x.middleName||p?.middle_name||'',
          lastName:x.lastName||p?.last_name||'',
          gender:x.gender||(p?.gender||'').toUpperCase()||'',
          dateOfBirth:x.dateOfBirth||p?.date_of_birth?.split('T')[0]||'',
          mobile:x.mobile||p?.phone?.replace('+254','0')||'',
          shaBeneficiaryCrId:crId,
          insuranceProvider:'SHIF',isSHAPatient:true,
        }));
        const re=await m.shaCheckEligibility({identificationNumber:idNo,identificationType:idType,serviceType:'OUTPATIENT'});
        setShaResult(re?.data);
      }else{
        setShaResult({error:true,message:'Patient not found in SHA registry. Verify the ID number.'});
      }
    }catch(e:any){setShaResult({error:true,message:e?.response?.data?.message||e?.message||'SHA search failed'});}
    setShaSearching(false);
  };

  // Check insurance eligibility
  const checkInsuranceEligibility=async()=>{
    console.log('jnjnj')
    if(!form.otherPolicyNumber&&!form.nhifNumber){setError('Enter policy or NHIF number first');return;}
    setCheckingInsurance(true);setInsuranceEligibility(null);
    try{
      const expiry=form.otherInsuranceExpiry?new Date(form.otherInsuranceExpiry):null;
      const eligible=!expiry||expiry>new Date();
      setInsuranceEligibility({eligible,provider:form.otherInsuranceProvider,policy:form.otherPolicyNumber||form.nhifNumber});
    }catch{}
    setCheckingInsurance(false);
  };

  // Duplicate check before submit
  const checkDuplicates=async():Promise<any[]>=>{
    try{
      const q=form.mobile||form.nationalId||`${form.firstName} ${form.lastName}`.trim();
      if(!q)return[];
      const r=await api.searchPatients(q).catch(()=>({data:{}}));
      const list=Array.isArray(r?.data?.patients)?r.data.patients:Array.isArray(r?.data?.data)?r.data.data:Array.isArray(r?.data)?r.data:[];
      // Filter out current patient in edit mode
      return list.filter((p:any)=>p.id!==id);
    }catch{return[];}
  };

  // Route after registration
  const routeTo=async(destination:'triage'|'opd'|'ipd'|'appointment')=>{
    const patId=registeredPatient?.id||id;
    if(!patId){setError('Save patient first');return;}
    const patName=`${registeredPatient?.firstName||registeredPatient?.first_name||form.firstName} ${registeredPatient?.lastName||registeredPatient?.last_name||form.lastName}`.trim();
    if(destination==='ipd'){nav(`/ipd/admit?patientId=${patId}`);return;}
    if(destination==='appointment'){nav(`/appointments/book?patientId=${patId}&type=OPD`);return;}
    try{
      await (api as any).post('/opd/queue',{patientId:patId,destination,patientName:patName,uhid:registeredPatient?.uhid,priority:'ROUTINE',source:'REGISTRATION'}).catch(()=>{});
      setTimeout(()=>nav(destination==='triage'?'/nursing':'/opd'),800);
    }catch{nav('/opd');}
  };

  // Submit with duplicate check
  const submit=async(force=false)=>{
    if(!form.firstName||!form.lastName||!form.mobile||!form.gender){
      setError('First name, last name, mobile and gender are required');return;
    }
    // Duplicate check (skip in edit mode or forced)
    if(!isEdit&&!force){
      const dupes=await checkDuplicates();
      if(dupes.length>0){
        setDuplicates(dupes);
        setShowDuplicateWarning(true);
        return;
      }
    }
    setShowDuplicateWarning(false);setDuplicates([]);
    setSaving(true);setError('');
    try{
      const payload:any={
        firstName:form.firstName,lastName:form.lastName,middleName:form.middleName||null,
        dateOfBirth:form.dateOfBirth||null,gender:form.gender,
        bloodGroup:form.bloodGroup||null,maritalStatus:form.maritalStatus||null,
        religion:form.religion||null,nationality:form.nationality,
        occupation:form.occupation||null,educationLevel:form.educationLevel||null,
        mobile:form.mobile,phone:form.mobile,alternatePhone:form.alternatePhone||null,
        email:form.email||null,
        addressLine1:form.addressLine1||null,city:form.city||null,
        county:form.county||null,state:form.county||form.state||null,
        subCounty:form.subCounty||null,ward:form.ward||null,
        postalCode:form.postalCode||null,country:form.country,
        emergencyContactName:form.emergencyContactName||null,
        emergencyContactPhone:form.emergencyContactPhone||null,
        emergencyContactRelation:form.emergencyContactRelation||null,
        nationalId:form.nationalId||null,alienId:form.alienId||null,
        hudumaNumber:form.hudumaNumber||null,kenyanIdType:form.kenyanIdType||null,
        passportNumber:form.passportNumber||null,
        shaBeneficiaryCrId:form.shaBeneficiaryCrId||null,
        nhifNumber:form.nhifNumber||null,
        insuranceProvider:form.isSHAPatient?'SHIF':(form.hasOtherInsurance?form.otherInsuranceProvider:form.insuranceProvider)||null,
        insurancePolicyNumber:form.hasOtherInsurance?form.otherPolicyNumber:form.insurancePolicyNumber||null,
        insuranceExpiry:form.hasOtherInsurance?form.otherInsuranceExpiry:form.insuranceExpiry||null,
        groupInsuranceNumber:form.groupInsuranceNumber||null,
        insuranceId:form.insuranceId||null,
        knownAllergies:form.knownAllergies||null,chronicConditions:form.chronicConditions||null,
        currentMedications:form.currentMedications||null,
        referredBy:form.referredBy||null,referralSource:form.referralSource||null,
        referralHospital:form.referralHospital||null,
        patientType:form.patientType,isVIP:form.isVIP,isMLCPatient:form.isMLCPatient,
        fatherName:form.fatherName||null,husbandName:form.husbandName||null,motherName:form.motherName||null,
        preferredLanguage:form.preferredLanguage||null,requiresInterpreter:form.requiresInterpreter,
      };
      if(isEdit){
        await api.updatePatient?.(id!,payload);
        setMsg('✅ Patient updated successfully');
        setRegisteredPatient({...payload,id,uhid:'Updated'});
      }else{
        const r=await api.createPatient?.(payload);
        const pat=r?.data?.data||r?.data;
        setMsg(`✅ Patient registered! UHID: ${pat?.uhid||'Generated'}`);
        setRegisteredPatient(pat);
      }
    }catch(e:any){setError(e.response?.data?.message||'Registration failed.');}
    setSaving(false);
  };

  // SHA result display
  const renderSHAResult=()=>{
    if(!shaResult)return null;
    if(shaResult.error)return<div className="mt-3 p-3 rounded-xl bg-red-50 border border-red-200 text-sm text-red-700">❌ {shaResult.message}</div>;
    const isEligible=shaResult.schemes?.some((s:any)=>s?.coverage?.status==='1')||shaResult.statusCode==='10';
    const schemes:any[]=shaResult.schemes||[];
    return(
      <div className={`mt-3 p-4 rounded-2xl border-2 space-y-2 ${isEligible?'bg-emerald-50 border-emerald-300':'bg-red-50 border-red-200'}`}>
        <div className="flex items-center justify-between">
          <p className={`font-black text-base ${isEligible?'text-emerald-700':'text-red-600'}`}>{isEligible?'✅ SHA ELIGIBLE':'❌ NOT ELIGIBLE'}</p>
          {(shaResult.memberCrNumber||form.shaBeneficiaryCrId)&&<span className="font-mono text-xs bg-white px-2 py-1 rounded-lg border">{shaResult.memberCrNumber||form.shaBeneficiaryCrId}</span>}
        </div>
        {schemes.map((s:any,i:number)=>{
          const covered=s.coverage?.status==='1';
          return<div key={i} className={`flex items-center justify-between rounded-xl px-3 py-2 text-xs border ${covered?'bg-white border-emerald-200':'bg-red-50 border-red-200'}`}>
            <div><p className="font-bold">{s.schemeName}</p><p className="text-slate-500">{s.memberType}{s.coverage?.message?' · '+s.coverage.message:''}</p></div>
            <span className={`px-2 py-0.5 rounded-full font-bold ${covered?'bg-emerald-100 text-emerald-700':'bg-red-100 text-red-600'}`}>{covered?'COVERED':'NOT COVERED'}</span>
          </div>;
        })}
        {isEligible&&<p className="text-xs text-emerald-700 font-semibold">✓ SHA eligibility saved — available in all billing windows</p>}
      </div>
    );
  };

  return(
    <Layout>
      <div className="p-6 max-w-5xl mx-auto">
        {/* Header */}
        <div className="flex items-center justify-between mb-6">
          <div>
            <h1 className="text-2xl font-bold text-gray-900">{isEdit?'Edit Patient':'New Patient Registration'}</h1>
            <p className="text-gray-500 text-sm mt-1">{isEdit?'Update patient information':'Register a new patient — system will check for duplicates before saving'}</p>
          </div>
          <div className="flex gap-2">
            <button onClick={()=>nav('/patients')} className={BTN2}>← Patients</button>
          </div>
        </div>

        {error&&<div className="mb-4 p-3 bg-red-50 border border-red-200 text-red-700 rounded-xl text-sm flex justify-between">{error}<button onClick={()=>setError('')} className="ml-2 text-red-400">✕</button></div>}
        {msg&&<div className="mb-4 p-4 bg-green-50 border border-green-200 text-green-800 rounded-xl text-sm font-semibold">{msg}</div>}

        {/* DUPLICATE WARNING */}
        {showDuplicateWarning&&duplicates.length>0&&(
          <div className="mb-5 bg-amber-50 border-2 border-amber-400 rounded-2xl p-5">
            <div className="flex items-start gap-3 mb-4">
              <span className="text-2xl">⚠️</span>
              <div>
                <p className="font-black text-amber-800 text-lg">Possible Duplicate Patient Found</p>
                <p className="text-amber-700 text-sm mt-1">The following patient(s) already exist with similar details. Please review before registering a new record.</p>
              </div>
            </div>
            <div className="space-y-3 mb-4">
              {duplicates.slice(0,3).map((p:any)=>(
                <div key={p.id} className="bg-white rounded-xl border border-amber-200 p-4 flex items-center justify-between">
                  <div>
                    <p className="font-bold text-slate-800">{p.firstName||p.first_name} {p.middleName||p.middle_name||''} {p.lastName||p.last_name}</p>
                    <div className="flex gap-3 mt-1 text-xs text-slate-500">
                      <span className="font-mono font-bold text-[#02357A]">{p.uhid}</span>
                      <span>{p.mobile||p.phone||'—'}</span>
                      <span>{p.gender}</span>
                      <span>{(p.dateOfBirth||p.date_of_birth||'').split('T')[0]||'—'}</span>
                    </div>
                    {(p.nationalId||p.national_id)&&<p className="text-xs text-slate-500 mt-0.5">ID: {p.nationalId||p.national_id}</p>}
                    {(p.shaBeneficiaryCrId||p.sha_beneficiary_cr_id)&&<p className="text-xs text-teal-600 font-semibold mt-0.5">SHA: {p.shaBeneficiaryCrId||p.sha_beneficiary_cr_id}</p>}
                  </div>
                  <div className="flex gap-2 flex-shrink-0">
                    <button onClick={()=>nav(`/patients/${p.id}`)} className="text-xs border border-slate-200 hover:bg-slate-50 px-3 py-1.5 rounded-lg font-medium">View Patient</button>
                    <button onClick={()=>{
                      // Use this existing patient for routing
                      setRegisteredPatient(p);
                      setShowDuplicateWarning(false);
                      setMsg(`✅ Using existing patient: ${p.firstName||p.first_name} ${p.lastName||p.last_name} — UHID: ${p.uhid}`);
                    }} className={BTNT+' !py-1.5 !px-3 !text-xs'}>Use This Patient →</button>
                  </div>
                </div>
              ))}
            </div>
            <div className="flex gap-3">
              <button onClick={()=>{setShowDuplicateWarning(false);setDuplicates([]);}} className={BTN2+' flex-1'}>← Go Back & Edit</button>
              <button onClick={()=>submit(true)} className="flex-1 py-2.5 px-5 bg-amber-600 hover:bg-amber-700 text-white font-bold rounded-xl text-sm transition-all">
                Register Anyway (Not a Duplicate)
              </button>
            </div>
          </div>
        )}

        {/* POST-REGISTRATION ROUTING */}
        {registeredPatient&&(
          <div className="mb-5 bg-[#02357A] rounded-2xl p-5 text-white">
            <div className="flex items-start justify-between mb-4">
              <div>
                <p className="text-xs text-white/60 uppercase mb-1">Patient Registered</p>
                <p className="text-xl font-black">{registeredPatient.firstName||registeredPatient.first_name} {registeredPatient.lastName||registeredPatient.last_name}</p>
                <p className="font-mono text-white/80 text-sm mt-0.5">UHID: {registeredPatient.uhid||'—'}</p>
                {(registeredPatient.shaBeneficiaryCrId||registeredPatient.sha_beneficiary_cr_id)&&
                  <p className="text-xs mt-1 bg-teal-500/30 inline-block px-2 py-0.5 rounded-full">SHA CR: {registeredPatient.shaBeneficiaryCrId||registeredPatient.sha_beneficiary_cr_id}</p>}
              </div>
              <button onClick={()=>{setRegisteredPatient(null);setForm({...DEF});setMsg('');}} className="text-xs bg-white/20 hover:bg-white/30 px-3 py-1.5 rounded-lg">+ New Patient</button>
            </div>
            <p className="text-xs text-white/60 mb-3 font-semibold uppercase tracking-wide">What would you like to do next?</p>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
              <button onClick={()=>routeTo('appointment')} className="flex flex-col items-center gap-1.5 bg-white text-[#02357A] font-bold py-3 px-3 rounded-xl text-xs hover:bg-blue-50 transition-all">
                <span className="text-xl">📅</span><span>Book OPD Appt</span><span className="text-[10px] text-slate-400 font-normal">Scheduled visit</span>
              </button>
              {/* <button onClick={()=>routeTo('triage')} className="flex flex-col items-center gap-1.5 bg-amber-500 hover:bg-amber-400 text-white font-bold py-3 px-3 rounded-xl text-xs transition-all">
                <span className="text-xl">🩺</span><span>Walk-in Triage</span><span className="text-[10px] text-white/70 font-normal">Nurse assessment</span>
              </button> */}
              {/* <button onClick={()=>routeTo('opd')} className="flex flex-col items-center gap-1.5 bg-[#039089] hover:bg-teal-600 text-white font-bold py-3 px-3 rounded-xl text-xs transition-all">
                <span className="text-xl">👨‍⚕️</span><span>Walk-in OPD</span><span className="text-[10px] text-white/70 font-normal">Direct to doctor</span>
              </button> */}
              <button onClick={()=>routeTo('ipd')} className="flex flex-col items-center gap-1.5 bg-purple-600 hover:bg-purple-500 text-white font-bold py-3 px-3 rounded-xl text-xs transition-all">
                <span className="text-xl">🛏️</span><span>Admit IPD</span><span className="text-[10px] text-white/70 font-normal">Inpatient</span>
              </button>
              <div className="flex flex-col items-center justify-center gap-1.5 bg-teal-600 text-white font-bold py-3 px-3 rounded-xl text-xs">
                <FileShaClaimButton
                  patientId={registeredPatient.id}
                  patientName={`${registeredPatient.firstName||registeredPatient.first_name||''} ${registeredPatient.lastName||registeredPatient.last_name||''}`.trim()}
                  patientCrId={registeredPatient.shaBeneficiaryCrId||registeredPatient.sha_beneficiary_cr_id}
                  encounterId={registeredPatient.id}
                  serviceName="Outpatient consultation"
                  from="opd"
                  className="text-xs px-2 py-1 bg-white text-teal-800 rounded-lg font-bold"
                />
              </div>
            </div>
          </div>
        )}

        {/* REGISTRATION FORM */}
        {/* Insurance & SHA */}
        <SECTION title="Insurance & SHA Coverage" icon="🛡️" badge="Optional">
          <div className="space-y-4">
            <label className={`flex items-start gap-3 p-4 rounded-xl border-2 cursor-pointer transition-all ${form.isSHAPatient?'border-teal-400 bg-teal-50':'border-slate-200 hover:border-slate-300'}`}>
              <input type="checkbox" checked={form.isSHAPatient} onChange={e=>{f('isSHAPatient',e.target.checked);if(!e.target.checked){setShaResult(null);setShaPatient(null);}}} className="w-5 h-5 rounded mt-0.5 flex-shrink-0"/>
              <div><p className="font-bold text-slate-800">Is Patient a SHA Beneficiary</p><p className="text-xs text-slate-500 mt-0.5">Social Health Authority (SHA/SHIF) — Kenya</p></div>
            </label>
            {form.isSHAPatient&&(
              <div className="bg-teal-50 rounded-xl border border-teal-200 p-4 space-y-4">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <FLD label="ID Type" required>
                    <SEL value={form.kenyanIdType} onChange={(e:any)=>f('kenyanIdType',e.target.value)}>
                      {['NATIONAL_ID','PASSPORT','ALIEN_ID','REFUGEE_ID','BIRTH_CERT','HUDUMA_NUMBER'].map(t=><option key={t} value={t}>{t.replace(/_/g,' ')}</option>)}
                    </SEL>
                  </FLD>
                  <FLD label="ID Number" required>
                    <input className={INPF} value={form.nationalId} onChange={e=>{f('nationalId',e.target.value);f('passportNumber',e.target.value);}} placeholder="e.g. 12345678"/>
                  </FLD>
                  <FLD label="SHA Beneficiary CR ID">
                    <input className={INPF} value={form.shaBeneficiaryCrId} onChange={e=>f('shaBeneficiaryCrId',e.target.value)} placeholder="Auto-filled on eligibility check"/>
                  </FLD>
                </div>
                <button type="button" onClick={searchAndFillFromSHA} disabled={shaSearching||!form.nationalId} className={BTNT+' w-full flex items-center justify-center gap-2'}>
                  {shaSearching?'⟳ Searching SHA Registry...':'🔍 Search SHA & Check Eligibility'}
                </button>
                {!form.nationalId&&<p className="text-xs text-amber-600">⚠️ Enter ID Number first</p>}
                {shaPatient&&(
                  <div className="bg-white rounded-xl border border-teal-200 p-3 space-y-1">
                    <p className="text-xs font-bold text-teal-700">✓ Found in SHA Registry</p>
                    <p className="font-bold">{shaPatient.fullName}</p>
                    <p className="text-xs text-slate-500">CR: <span className="font-mono text-teal-700">{shaPatient.crId}</span> · {shaPatient.gender}</p>
                    <p className="text-xs text-emerald-600">Name, DOB, phone auto-filled ✓</p>
                  </div>
                )}
                {renderSHAResult()}
              </div>
            )}
            <label className={`flex items-start gap-3 p-4 rounded-xl border-2 cursor-pointer transition-all ${form.hasOtherInsurance?'border-blue-400 bg-blue-50':'border-slate-200 hover:border-slate-300'}`}>
              <input type="checkbox" checked={form.hasOtherInsurance} onChange={e=>f('hasOtherInsurance',e.target.checked)} className="w-5 h-5 rounded mt-0.5 flex-shrink-0"/>
              <div><p className="font-bold text-slate-800">Does Patient have Other Insurance?</p><p className="text-xs text-slate-500 mt-0.5">Private insurance, NHIF, AAR, Jubilee, etc.</p></div>
            </label>
            {form.hasOtherInsurance&&(
              <div className="bg-blue-50 rounded-xl border border-blue-200 p-4 space-y-4">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <FLD label="Insurance Provider" required>
                    <SEL value={form.otherInsuranceProvider} onChange={(e:any)=>f('otherInsuranceProvider',e.target.value)}>
                      <option value="">Select provider...</option>
                      {INSURANCE_PROVIDERS.map(p=><option key={p}>{p}</option>)}
                    </SEL>
                  </FLD>
                  <FLD label="Policy / Member Number" required><input className={INPF} value={form.otherPolicyNumber} onChange={e=>f('otherPolicyNumber',e.target.value)} placeholder="Policy or member number"/></FLD>
                  <FLD label="Policy Expiry Date"><input className={INPF} type="date" value={form.otherInsuranceExpiry} onChange={e=>f('otherInsuranceExpiry',e.target.value)}/></FLD>
                  <FLD label="NHIF Member Number"><input className={INPF} value={form.nhifNumber} onChange={e=>f('nhifNumber',e.target.value)} placeholder="NHIF membership number"/></FLD>
                  <FLD label="Insurance Card ID"><input className={INPF} value={form.insuranceId} onChange={e=>f('insuranceId',e.target.value)} placeholder="Insurance card number"/></FLD>
                  <FLD label="Principal Member Name"><input className={INPF} value={form.groupInsuranceNumber} onChange={e=>f('groupInsuranceNumber',e.target.value)} placeholder="Principal member"/></FLD>
                </div>
                {/* <button type="button" onClick={checkInsuranceEligibility} disabled={checkingInsurance} className="bg-[#02357A] hover:bg-[#015CA6] text-white font-bold py-2 px-4 rounded-xl text-sm w-full disabled:opacity-50">
                  {checkingInsurance?'⟳ Checking...':'🔍 Check Insurance Eligibility'}
                </button> */}
                {insuranceEligibility&&(
                  <div className={`p-3 rounded-xl border text-sm ${insuranceEligibility.eligible?'bg-green-50 border-green-200 text-green-700':'bg-red-50 border-red-200 text-red-700'}`}>
                    {insuranceEligibility.eligible?`✅ ${insuranceEligibility.provider||'Insurance'} eligible · Policy: ${insuranceEligibility.policy||'—'}`:' ❌ Insurance not eligible or policy expired'}
                    {insuranceEligibility.eligible&&<p className="text-xs mt-1 opacity-70">Status saved — available in OPD and IPD billing</p>}
                  </div>
                )}
              </div>
            )}
          </div>
        </SECTION>

        {/* Basic Info */}
        <SECTION title="Basic Information" icon="👤" badge="Required">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <FLD label="First Name" required><input className={INPF} value={form.firstName} onChange={e=>f('firstName',e.target.value)} placeholder="First name"/></FLD>
            <FLD label="Middle Name"><input className={INPF} value={form.middleName} onChange={e=>f('middleName',e.target.value)} placeholder="Middle name"/></FLD>
            <FLD label="Last Name / Surname" required><input className={INPF} value={form.lastName} onChange={e=>f('lastName',e.target.value)} placeholder="Last name"/></FLD>
            <FLD label="Date of Birth" required><input className={INPF} type="date" value={form.dateOfBirth} onChange={e=>f('dateOfBirth',e.target.value)}/></FLD>
            <FLD label="Gender" required>
              <SEL value={form.gender} onChange={(e:any)=>f('gender',e.target.value)}>
                <option value="">Select Gender</option>
                {['MALE','FEMALE','TRANSGENDER','OTHER'].map(g=><option key={g}>{g}</option>)}
              </SEL>
            </FLD>
            <FLD label="Blood Group">
              <SEL value={form.bloodGroup} onChange={(e:any)=>f('bloodGroup',e.target.value)}>
                <option value="">{t('common.unknown','Unknown')}</option>
                {['A+','A-','B+','B-','AB+','AB-','O+','O-'].map(g=><option key={g}>{g}</option>)}
              </SEL>
            </FLD>
            <FLD label="Marital Status">
              <SEL value={form.maritalStatus} onChange={(e:any)=>f('maritalStatus',e.target.value)}>
                <option value="">{t('common.select','Select')}</option>
                {['SINGLE','MARRIED','DIVORCED','WIDOWED','SEPARATED'].map(s=><option key={s}>{s}</option>)}
              </SEL>
            </FLD>
            <FLD label="Religion">
              <SEL value={form.religion} onChange={(e:any)=>f('religion',e.target.value)}>
                <option value="">{t('common.select','Select')}</option>
                {['CHRISTIAN','MUSLIM','HINDU','TRADITIONALIST','OTHER'].map(r=><option key={r}>{r}</option>)}
              </SEL>
            </FLD>
            <FLD label="Nationality"><input className={INPF} value={form.nationality} onChange={e=>f('nationality',e.target.value)} placeholder="Kenyan"/></FLD>
            <FLD label="Occupation"><input className={INPF} value={form.occupation} onChange={e=>f('occupation',e.target.value)} placeholder="Job/Profession"/></FLD>
            <FLD label="Education Level">
              <SEL value={form.educationLevel} onChange={(e:any)=>f('educationLevel',e.target.value)}>
                <option value="">{t('common.select','Select')}</option>
                {['NO_FORMAL_EDUCATION','PRIMARY','SECONDARY','CERTIFICATE','DIPLOMA','DEGREE','POST_GRADUATE','OTHER'].map(e=><option key={e} value={e}>{e.replace(/_/g,' ')}</option>)}
              </SEL>
            </FLD>
            <FLD label="Preferred Language">
              <SEL value={form.preferredLanguage} onChange={(e:any)=>f('preferredLanguage',e.target.value)}>
                {['English','Swahili','Kikuyu','Luo','Luhya','Kalenjin','Kamba','Somali','Other'].map(l=><option key={l}>{l}</option>)}
              </SEL>
            </FLD>
            <FLD label="Patient Type">
              <SEL value={form.patientType} onChange={(e:any)=>f('patientType',e.target.value)}>
                {['GENERAL','NHIF','SHA_BENEFICIARY','CORPORATE','VIP','STAFF','FOREIGNER','REFUGEE','GOK_EMPLOYEE','COUNTY_EMPLOYEE'].map(t=><option key={t} value={t}>{t.replace(/_/g,' ')}</option>)}
              </SEL>
            </FLD>
            {!form.isSHAPatient &&
            <>
            <FLD label="ID Type" required>
              <SEL value={form.kenyanIdType} onChange={(e:any)=>f('kenyanIdType',e.target.value)}>
                {['NATIONAL_ID','PASSPORT','ALIEN_ID','REFUGEE_ID','BIRTH_CERT','HUDUMA_NUMBER'].map(t=><option key={t} value={t}>{t.replace(/_/g,' ')}</option>)}
              </SEL>
            </FLD>
            <FLD label="ID Number" required>
              <input className={INPF} value={form.nationalId} onChange={e=>{f('nationalId',e.target.value);f('passportNumber',e.target.value);}} placeholder="e.g. 12345678"/>
            </FLD>
            </>}
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
            <FLD label="Father's Name"><input className={INPF} value={form.fatherName} onChange={e=>f('fatherName',e.target.value)} placeholder="Father's full name"/></FLD>
            <FLD label="Husband's Name"><input className={INPF} value={form.husbandName} onChange={e=>f('husbandName',e.target.value)} placeholder="Husband's name (if applicable)"/></FLD>
            <FLD label="Mother's Name"><input className={INPF} value={form.motherName} onChange={e=>f('motherName',e.target.value)} placeholder="Mother's name"/></FLD>
          </div>
          <div className="flex flex-wrap gap-4 mt-4">
            <label className="flex items-center gap-2 cursor-pointer"><input type="checkbox" checked={form.isVIP} onChange={e=>f('isVIP',e.target.checked)} className="w-4 h-4"/><span className="text-sm font-medium">VIP Patient</span></label>
            <label className="flex items-center gap-2 cursor-pointer"><input type="checkbox" checked={form.requiresInterpreter} onChange={e=>f('requiresInterpreter',e.target.checked)} className="w-4 h-4"/><span className="text-sm">Requires Interpreter</span></label>
            <label className="flex items-center gap-2 cursor-pointer"><input type="checkbox" checked={form.isMLCPatient} onChange={e=>f('isMLCPatient',e.target.checked)} className="w-4 h-4"/><span className="text-sm text-red-600 font-medium">MLC Case</span></label>
          </div>
        </SECTION>

        {/* Contact */}
        <SECTION title="Contact Information" icon="📞" badge="Required">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <FLD label="Mobile Number" required><input className={INPF} value={form.mobile} onChange={e=>f('mobile',e.target.value)} placeholder="+254 7XX XXX XXX"/></FLD>
            <FLD label="Alternate Phone"><input className={INPF} value={form.alternatePhone} onChange={e=>f('alternatePhone',e.target.value)} placeholder="Alternate number"/></FLD>
            <FLD label="Email Address"><input className={INPF} type="email" value={form.email} onChange={e=>f('email',e.target.value)} placeholder="patient@email.com"/></FLD>
          </div>
        </SECTION>

        {/* Address */}
        <SECTION title="Address Details" icon="📍" badge="Optional">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div className="col-span-3"><FLD label="Address"><input className={INPF} value={form.addressLine1} onChange={e=>f('addressLine1',e.target.value)} placeholder="House no., Street, Area"/></FLD></div>
            <FLD label="City / Town"><input className={INPF} value={form.city} onChange={e=>f('city',e.target.value)} placeholder="City or town"/></FLD>
            <FLD label="County">
              <SEL value={form.county||form.state} onChange={(e:any)=>{f('county',e.target.value);f('state',e.target.value);f('subCounty','');}}>
                <option value="">Select County</option>
                {counties.map(c=><option key={c}>{c}</option>)}
              </SEL>
            </FLD>
            <FLD label="Sub-County">
              <SEL value={form.subCounty} onChange={(e:any)=>f('subCounty',e.target.value)}>
                <option value="">{(form.county||form.state)?'Select sub-county':'Select a county first'}</option>
                {subCountyOptions.map(s=><option key={s}>{s}</option>)}
                {form.subCounty&&!subCountyOptions.includes(form.subCounty)&&<option value={form.subCounty}>{form.subCounty}</option>}
              </SEL>
            </FLD>
            <FLD label="Ward / Village"><input className={INPF} value={form.ward} onChange={e=>f('ward',e.target.value)} placeholder="Ward or village"/></FLD>
            <FLD label="Postal Code"><input className={INPF} value={form.postalCode} onChange={e=>f('postalCode',e.target.value)} placeholder="e.g. 00100"/></FLD>
          </div>
        </SECTION>

        {/* Next of Kin */}
        <SECTION title="Next of Kin / Emergency Contact" icon="🚨" badge="Optional">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <FLD label="Contact Name"><input className={INPF} value={form.emergencyContactName} onChange={e=>f('emergencyContactName',e.target.value)} placeholder="Full name"/></FLD>
            <FLD label="Contact Phone"><input className={INPF} value={form.emergencyContactPhone} onChange={e=>f('emergencyContactPhone',e.target.value)} placeholder="Mobile number"/></FLD>
            <FLD label="Relation">
              <SEL value={form.emergencyContactRelation} onChange={(e:any)=>f('emergencyContactRelation',e.target.value)}>
                <option value="">{t('common.select','Select')}</option>
                {['SPOUSE','FATHER','MOTHER','SON','DAUGHTER','SIBLING','FRIEND','GUARDIAN','OTHER'].map(r=><option key={r}>{r}</option>)}
              </SEL>
            </FLD>
          </div>
        </SECTION>

        {/* Medical Background */}
        <SECTION title="Medical Background" icon="🩺" badge="Optional">
          <div className="grid grid-cols-1 gap-4">
            <FLD label="Known Allergies"><textarea value={form.knownAllergies} onChange={e=>f('knownAllergies',e.target.value)} rows={2} className={INPF} placeholder="Drug allergies, food allergies, latex allergy…"/></FLD>
            <FLD label="Chronic Conditions"><textarea value={form.chronicConditions} onChange={e=>f('chronicConditions',e.target.value)} rows={2} className={INPF} placeholder="Diabetes, Hypertension, Asthma…"/></FLD>
            <FLD label="Current Medications"><textarea value={form.currentMedications} onChange={e=>f('currentMedications',e.target.value)} rows={2} className={INPF} placeholder="Ongoing medications with doses…"/></FLD>
          </div>
        </SECTION>

        {/* Referral */}
        <SECTION title="Referral Information" icon="🔗" badge="Optional">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <FLD label="Referral Source">
              <SEL value={form.referralSource} onChange={(e:any)=>f('referralSource',e.target.value)}>
                <option value="">{t('common.select','Select')}</option>
                {['SELF','DOCTOR_REFERRAL','CAMP','ONLINE','INSURANCE','CORPORATE','GOVERNMENT','OTHER'].map(s=><option key={s}>{s}</option>)}
              </SEL>
            </FLD>
            <FLD label="Referred By"><input className={INPF} value={form.referredBy} onChange={e=>f('referredBy',e.target.value)} placeholder="Referring doctor name"/></FLD>
            <FLD label="Referral Hospital"><input className={INPF} value={form.referralHospital} onChange={e=>f('referralHospital',e.target.value)} placeholder="Referring hospital"/></FLD>
          </div>
        </SECTION>

        {/* Actions */}
        <div className="flex gap-3 justify-end mt-6 pb-8">
          <button onClick={()=>nav('/patients')} className={BTN2}>{t('common.cancel','Cancel')}</button>
          <button onClick={()=>submit(false)} disabled={saving} className={BTN+' px-8'}>
            {saving?'Checking & Saving…':(isEdit?'Update Patient':'Register Patient')}
          </button>
        </div>
      </div>
    </Layout>
  );
}
